module.exports = __webpack_public_path__ + "static/media/avatar-s-11.5097b024.jpg";